import { firestore } from '@src/api/Firebase/Firebase';
import { collection } from 'firebase/firestore';

export enum PaymentMethods {
    cash = 'Cash',
    creditCard = 'Credit Card',
    bankTransfer = 'Bank Transfer'
}

export interface SalesChannel {
    id?: string;
    photoSrc: string;
    name: string;
    paymentMethods: PaymentMethods[];
    branchOfficesAvailable: string[];
    creditCardCommission: number;
}

export const SALES_CHANNELS_COLLECTION = 'sales-channels';

export const salesChannelsRef = collection(firestore, SALES_CHANNELS_COLLECTION);
